import LandingPage from "pages/_Landing";
import CustomerAppointment from "pages/Customer/Appointment";
import CustomerDashboard from "pages/Customer/Dashboard";
import CustomerHome from "pages/Customer/LandingPageHome";
import ReviewCustomer from "pages/Customer/Review";
import UpdateCustomerProfile from "pages/Customer/UpdateProfile";
import CustomerVehicle from "pages/Customer/Vehicle";



const customerRoutes = [
    {
        id:1,
        link:'/',
        component:<LandingPage/>

    },
    {
        id:2,
        link:"customer/dashboard",
        component:<CustomerDashboard/>
    },
    {
        id:3,
        link:'customer/vehicle',
        component:<CustomerVehicle/>

    },
    {
        id:4,
        link:'customer/appointment',
        subList:[
            {
            id:41,
            link:'approvedAppointment',
            component:<CustomerAppointment/>
            },
        ]
        },
    {
        id:5,
        link:'customer/profile',
        component:<UpdateCustomerProfile/>

    },
    {
        id:6,
        link:'customer/review',
        component:<ReviewCustomer/>
    },
]

export default customerRoutes